import apolloClient from '../../apolloClient';
import authMutations from '../mutations/auth';

const signUp = async (variables) =>
  apolloClient.mutate({
    mutation: authMutations.SIGNUP,
    variables,
  });

const signIn = async (variables) =>
  apolloClient.mutate({
    mutation: authMutations.SIGNIN,
    variables,
  });

const signOut = async (variables) =>
  apolloClient.mutate({
    mutation: authMutations.SIGNOUT,
    variables,
  });

const forgotPassword = async (variables) =>
  apolloClient.mutate({
    mutation: authMutations.FORGOT_PASSWORD,
    variables,
  });

const refreshTokens = async (variables = {}) =>
  apolloClient.mutate({
    mutation: authMutations.REFRESH_TOKENS,
    variables,
  });

export default {
  signUp,
  signIn,
  signOut,
  forgotPassword,
  refreshTokens,
};
